import { useEffect, useState } from "react";
import Templete from "../../template/Template";
import { api } from "../../services/api";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircleIcon from "@mui/icons-material/Circle";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import ReplyIcon from "@mui/icons-material/Reply";
import PersonIcon from "@mui/icons-material/Person";
import RefreshIcon from "@mui/icons-material/Refresh";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Chip from "@mui/material/Chip";
import { DragDropContext, Droppable, Draggable, DropResult, DragStart } from "@hello-pangea/dnd";
import { KanbanModulo } from "../Configuracoes/TabKanbanModulos";
import ModalNovaTarefaKanban from "./ModalNovaTarefaKanban";

const STATUS_CONFIG: Record<string, { label: string; color: string }> = {
    aguardando: { label: "Aguardando", color: "#424242" },
    em_execucao: { label: "Em execução", color: "#1565c0" },
    aguardando_resposta: { label: "Aguardando resposta", color: "#f9a825" },
    finalizado: { label: "Finalizado", color: "#2e7d32" },
};

const STATUS_OPTIONS = Object.keys(STATUS_CONFIG);

type InstanciaTarefa = {
    id_kanban_instancia_tarefa: number;
    nome_tarefa: string;
    tempo_execucao_horas: number;
    tempo_definido_usuario?: number;
    ordem_tarefa: number;
    status: string;
    inicio_execucao?: string | null;
    justificativa_atraso?: string | null;
    atrasado_em?: string | null;
    id_kanban_modulo?: number;
    nome_modulo?: string;
};

type KanbanInstancia = {
    id_kanban_instancia: number;
    id_kanban_grupo: number;
    id_kanban_modulo: number;
    nome_instancia: string;
    nome_grupo?: string | null;
    id_usuario_responsavel?: number | null;
    nome_responsavel?: string | null;
    justificativa_retorno?: string | null;
    retornado_em?: string | null;
    tarefas: InstanciaTarefa[];
};

export default function Home() {
    const [modulos, setModulos] = useState<KanbanModulo[]>([]);
    const [instancias, setInstancias] = useState<KanbanInstancia[]>([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [dragOrigemIndex, setDragOrigemIndex] = useState<number | null>(null);
    const [infoLogin] = useState(() => JSON.parse(String(sessionStorage.getItem("infoLogin"))));
    // Menu de status
    const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
    const [menuTarefa, setMenuTarefa] = useState<InstanciaTarefa | null>(null);

    // Finalizar instância
    const [finalizarId, setFinalizarId] = useState<number | null>(null);

    // Collapse das etapas (chave: "instanciaId-nomeModulo")
    const [collapsedSections, setCollapsedSections] = useState<Record<string, boolean>>({});

    // Snackbar de aviso
    const [snackMsg, setSnackMsg] = useState("");

    // Retorno (mover para módulo anterior) — pede justificativa
    const [retornoPendente, setRetornoPendente] = useState<{ idInstancia: number; moduloDestinoId: number } | null>(null);
    const [justificativaRetorno, setJustificativaRetorno] = useState("");

    // Tempo de execução definido pelo usuário
    const [tempoPendente, setTempoPendente] = useState<{ tarefa: InstanciaTarefa; novoStatus: string } | null>(null);
    const [tempoInput, setTempoInput] = useState("");

    // Editar/Excluir bloco (só no primeiro módulo)
    const [editandoInstancia, setEditandoInstancia] = useState<KanbanInstancia | null>(null);
    const [nomeEditInstancia, setNomeEditInstancia] = useState("");
    const [excluindoInstancia, setExcluindoInstancia] = useState<KanbanInstancia | null>(null);

    // Justificativa de atraso
    const [atrasoPendente, setAtrasoPendente] = useState<{ tarefa: InstanciaTarefa; novoStatus: string } | null>(null);
    const [justificativaAtraso, setJustificativaAtraso] = useState("");

    // Modal de tarefas atrasadas
    const [modalAtrasadas, setModalAtrasadas] = useState(false);

    // Timer global — só roda quando existe tarefa em execução COM tempo definido
    const [agora, setAgora] = useState(() => Date.now());
    const temTimerAtivo = instancias.some(inst =>
        inst.tarefas.some(t => t.status === "em_execucao" && t.inicio_execucao && Number(t.tempo_execucao_horas) > 0)
    );
    useEffect(() => {
        if (!temTimerAtivo) return;
        const interval = setInterval(() => setAgora(Date.now()), 1000);
        return () => clearInterval(interval);
    }, [temTimerAtivo]);

    function getTempoRestante(tarefa: InstanciaTarefa): { texto: string; expirado: boolean } | null {
        if (tarefa.status !== "em_execucao" || !tarefa.inicio_execucao || Number(tarefa.tempo_execucao_horas) <= 0) return null;
        const inicio = new Date(tarefa.inicio_execucao).getTime();
        const limiteMs = tarefa.tempo_execucao_horas * 3600000;
        const fimMs = inicio + limiteMs;
        const diffMs = fimMs - agora;
        const expirado = diffMs <= 0;
        const absDiff = Math.abs(diffMs);
        const totalSeg = Math.floor(absDiff / 1000);
        const h = Math.floor(totalSeg / 3600);
        const m = Math.floor((totalSeg % 3600) / 60);
        const s = totalSeg % 60;
        const pad = (n: number) => String(n).padStart(2, "0");
        const texto = expirado
            ? `-${pad(h)}:${pad(m)}:${pad(s)}`
            : `${pad(h)}:${pad(m)}:${pad(s)}`;
        return { texto, expirado };
    }

    function toggleSection(key: string) {
        setCollapsedSections(prev => ({ ...prev, [key]: !prev[key] }));
    }

    function isParticipante(modulo: KanbanModulo) {
        return modulo.usuarios.some(u => u.id_usuario === infoLogin?.id_usuario);
    }

    function isParticipanteDoModuloId(idModulo: number) {
        const modulo = modulos.find(m => m.id_kanban_modulo === idModulo);
        return modulo ? isParticipante(modulo) : false;
    }

    function getModuloById(id: number) {
        return modulos.find(m => m.id_kanban_modulo === id);
    }

    useEffect(() => {
        fetchData();
        const interval = setInterval(() => fetchData(), 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    async function fetchData() {
        try {
            const [resModulos, resInstancias] = await Promise.all([
                api.get("/kanbanmodulos"),
                api.get("/kanbaninstancias"),
            ]);
            if (!resModulos.data.error) setModulos(resModulos.data);
            if (!resInstancias.data.error) setInstancias(resInstancias.data);
        } catch (err) {
            console.error("Erro ao carregar dados kanban", err);
        } finally {
            setLoading(false);
        }
    }

    function getInstanciasDoModulo(idModulo: number) {
        return instancias.filter(i => i.id_kanban_modulo === idModulo);
    }

    function handleOpenStatusMenu(e: React.MouseEvent<HTMLElement>, tarefa: InstanciaTarefa) {
        setMenuAnchor(e.currentTarget);
        setMenuTarefa(tarefa);
    }

    function handleCloseStatusMenu() {
        setMenuAnchor(null);
        setMenuTarefa(null);
    }

    async function handleChangeStatus(novoStatus: string) {
        if (!menuTarefa) return;
        const tarefa = menuTarefa;
        handleCloseStatusMenu();

        // Se a tarefa tem tempo definido pelo usuário e está mudando para em_execucao, pedir horas
        if (novoStatus === "em_execucao" && tarefa.tempo_definido_usuario) {
            setTempoPendente({ tarefa, novoStatus });
            setTempoInput("");
            return;
        }

        // Se a tarefa está em execução com timer expirado e está mudando de status, pedir justificativa de atraso
        if (tarefa.status === "em_execucao" && novoStatus !== "em_execucao") {
            const tempoInfo = getTempoRestante(tarefa);
            if (tempoInfo && tempoInfo.expirado) {
                setAtrasoPendente({ tarefa, novoStatus });
                setJustificativaAtraso("");
                return;
            }
        }

        executarChangeStatus(tarefa.id_kanban_instancia_tarefa, novoStatus);
    }

    async function executarChangeStatus(tarefaId: number, novoStatus: string, tempoHoras?: number, justAtraso?: string) {
        setInstancias(prev =>
            prev.map(inst => {
                const tarefaPertence = inst.tarefas.some(t => t.id_kanban_instancia_tarefa === tarefaId);
                return {
                    ...inst,
                    ...(tarefaPertence && !inst.id_usuario_responsavel ? {
                        id_usuario_responsavel: infoLogin?.id_usuario,
                        nome_responsavel: infoLogin?.nome_usuario,
                    } : {}),
                    tarefas: inst.tarefas.map(t => {
                        if (t.id_kanban_instancia_tarefa !== tarefaId) return t;
                        const tempoFinal = tempoHoras !== undefined ? tempoHoras : t.tempo_execucao_horas;
                        const temTempo = Number(tempoFinal) > 0;
                        return {
                            ...t,
                            status: novoStatus,
                            inicio_execucao: novoStatus === "em_execucao" && temTempo ? new Date().toISOString() : null,
                            ...(tempoHoras !== undefined ? { tempo_execucao_horas: tempoHoras } : {}),
                            ...(justAtraso ? { justificativa_atraso: justAtraso, atrasado_em: new Date().toISOString() } : {}),
                        };
                    }),
                };
            })
        );
        try {
            const body: any = { status: novoStatus };
            if (tempoHoras !== undefined) body.tempo_execucao_horas = tempoHoras;
            if (justAtraso) body.justificativa_atraso = justAtraso;
            const res = await api.put(`/updatekanbaninstanciatarefa/${tarefaId}`, body);
            if (res.data.error) {
                setSnackMsg(res.data.message);
                fetchData();
            }
        } catch {
            fetchData();
        }
    }

    function handleConfirmarAtraso() {
        if (!atrasoPendente || !justificativaAtraso.trim()) return;
        executarChangeStatus(atrasoPendente.tarefa.id_kanban_instancia_tarefa, atrasoPendente.novoStatus, undefined, justificativaAtraso.trim());
        setAtrasoPendente(null);
        setJustificativaAtraso("");
    }

    function handleConfirmarTempo() {
        if (!tempoPendente) return;
        const horas = parseFloat(tempoInput) || 0;
        if (horas <= 0) return;
        executarChangeStatus(tempoPendente.tarefa.id_kanban_instancia_tarefa, tempoPendente.novoStatus, horas);
        setTempoPendente(null);
        setTempoInput("");
    }

    function estaNoPrimeiroModulo(inst: KanbanInstancia) {
        return modulos.length > 0 && inst.id_kanban_modulo === modulos[0].id_kanban_modulo;
    }

    function handleEditarInstancia(inst: KanbanInstancia) {
        setEditandoInstancia(inst);
        setNomeEditInstancia(inst.nome_instancia);
    }

    async function handleSalvarEdicaoInstancia() {
        if (!editandoInstancia || !nomeEditInstancia.trim()) return;
        const id = editandoInstancia.id_kanban_instancia;
        const novoNome = nomeEditInstancia.trim();
        setInstancias(prev => prev.map(i => i.id_kanban_instancia === id ? { ...i, nome_instancia: novoNome } : i));
        setEditandoInstancia(null);
        try {
            await api.put(`/updatekanbaninstancia/${id}`, { nome_instancia: novoNome });
        } catch {
            fetchData();
        }
    }

    async function handleExcluirInstancia() {
        if (!excluindoInstancia) return;
        const id = excluindoInstancia.id_kanban_instancia;
        setInstancias(prev => prev.filter(i => i.id_kanban_instancia !== id));
        setExcluindoInstancia(null);
        try {
            await api.delete(`/deletekanbaninstancia/${id}`);
        } catch {
            fetchData();
        }
    }

    function handleDragStart(start: DragStart) {
        const origemId = Number(start.source.droppableId);
        const idx = modulos.findIndex(m => m.id_kanban_modulo === origemId);
        setDragOrigemIndex(idx);
    }

    async function handleDragEnd(result: DropResult) {
        setDragOrigemIndex(null);
        const { draggableId, source, destination } = result;
        if (!destination) return;
        if (source.droppableId === destination.droppableId) return;

        const idInstancia = Number(draggableId);
        const moduloOrigemId = Number(source.droppableId);
        const moduloDestinoId = Number(destination.droppableId);

        const moduloOrigem = getModuloById(moduloOrigemId);
        if (!moduloOrigem || !isParticipante(moduloOrigem)) return;

        // Só exige tarefas finalizadas ao avançar (mover para módulo posterior)
        const idxOrigem = modulos.findIndex(m => m.id_kanban_modulo === moduloOrigemId);
        const idxDestino = modulos.findIndex(m => m.id_kanban_modulo === moduloDestinoId);
        if (idxDestino > idxOrigem) {
            const instancia = instancias.find(i => i.id_kanban_instancia === idInstancia);
            if (instancia) {
                // Avançar: exige tarefas do módulo atual finalizadas
                const tarefasDoModuloOrigem = instancia.tarefas.filter(t => t.id_kanban_modulo === moduloOrigemId);
                const todasFinalizadas = tarefasDoModuloOrigem.length > 0 && tarefasDoModuloOrigem.every(t => t.status === "finalizado");
                if (!todasFinalizadas) {
                    setSnackMsg("Finalize todas as tarefas do módulo atual antes de mover o card.");
                    return;
                }

                // Verificar módulos intermediários (pulados) que possuem tarefas não finalizadas
                for (let i = idxOrigem + 1; i < idxDestino; i++) {
                    const moduloPulado = modulos[i];
                    const tarefasDoModuloPulado = instancia.tarefas.filter(t => t.id_kanban_modulo === moduloPulado.id_kanban_modulo);
                    if (tarefasDoModuloPulado.length > 0 && !tarefasDoModuloPulado.every(t => t.status === "finalizado")) {
                        setSnackMsg(`Existem tarefas pendentes no módulo "${moduloPulado.nome_modulo}". Não é possível pular este módulo.`);
                        return;
                    }
                }
            }
        }

        if (idxDestino < idxOrigem) {
            // Retroceder: pede justificativa antes de mover
            setRetornoPendente({ idInstancia, moduloDestinoId });
            setJustificativaRetorno("");
            return;
        }

        executarMove(idInstancia, moduloDestinoId);
    }

    async function executarMove(idInstancia: number, moduloDestinoId: number, justificativa?: string) {
        setInstancias(prev =>
            prev.map(inst =>
                inst.id_kanban_instancia === idInstancia
                    ? {
                        ...inst,
                        id_kanban_modulo: moduloDestinoId,
                        id_usuario_responsavel: null,
                        nome_responsavel: null,
                        justificativa_retorno: justificativa || null,
                        retornado_em: justificativa ? new Date().toISOString() : null,
                    }
                    : inst
            )
        );

        try {
            await api.put(`/movekanbaninstancia/${idInstancia}`, {
                id_kanban_modulo: moduloDestinoId,
                ...(justificativa ? { justificativa } : {}),
            });
        } catch {
            fetchData();
        }
    }

    function handleConfirmarRetorno() {
        if (!retornoPendente || !justificativaRetorno.trim()) return;
        executarMove(retornoPendente.idInstancia, retornoPendente.moduloDestinoId, justificativaRetorno.trim());
        setRetornoPendente(null);
        setJustificativaRetorno("");
    }

    function getStatusConfig(status: string) {
        return STATUS_CONFIG[status] || STATUS_CONFIG.aguardando;
    }

    function podeFinalizar(inst: KanbanInstancia) {
        if (modulos.length === 0 || inst.tarefas.length === 0) return false;
        const ultimoModulo = modulos[modulos.length - 1];
        if (inst.id_kanban_modulo !== ultimoModulo.id_kanban_modulo) return false;
        return inst.tarefas.every(t => t.status === "finalizado");
    }

    async function handleFinalizarInstancia() {
        if (!finalizarId) return;
        setInstancias(prev => prev.filter(i => i.id_kanban_instancia !== finalizarId));
        setFinalizarId(null);
        try {
            await api.delete(`/deletekanbaninstancia/${finalizarId}`);
        } catch {
            fetchData();
        }
    }

    return (
        <Templete menuActive="home">
            <Box sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 68px)", overflow: "hidden" }}>
                {!loading && modulos.length > 0 && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                        <Button
                            variant="contained"
                            onClick={() => setModalOpen(true)}
                            color="primary"
                        >
                            INICIAR BLOCO
                        </Button>
                        <Tooltip title="Atualizar dados" arrow>
                            <IconButton
                                onClick={() => fetchData()}
                                color="primary"
                                sx={{ border: "1px solid", borderColor: "primary.main" }}
                            >
                                <RefreshIcon />
                            </IconButton>
                        </Tooltip>
                        <Box sx={{ flex: 1 }} />
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, bgcolor: "#e3f2fd", border: "1px solid #90caf9", borderRadius: 2, px: 1.5, py: 0.6 }}>
                            <ViewKanbanIcon sx={{ fontSize: 20, color: "#1565c0" }} />
                            <Typography fontSize={14} fontWeight={700} color="#1565c0">
                                {instancias.length}
                            </Typography>
                            <Typography fontSize={13} color="#1565c0">
                                bloco{instancias.length !== 1 ? "s" : ""}
                            </Typography>
                        </Box>
                        {(() => {
                            const totalAtrasadas = instancias.reduce((acc, inst) =>
                                acc + inst.tarefas.filter(t => {
                                    const info = getTempoRestante(t);
                                    return info && info.expirado;
                                }).length, 0);
                            return (
                                <Box
                                    onClick={() => { if (totalAtrasadas > 0) setModalAtrasadas(true); }}
                                    sx={{
                                        display: "flex", alignItems: "center", gap: 0.8,
                                        bgcolor: totalAtrasadas > 0 ? "#ffebee" : "#f5f5f5",
                                        border: "1px solid",
                                        borderColor: totalAtrasadas > 0 ? "#ef5350" : "#bdbdbd",
                                        borderRadius: 2, px: 1.5, py: 0.6,
                                        cursor: totalAtrasadas > 0 ? "pointer" : "default",
                                        transition: "opacity 0.2s",
                                        "&:hover": totalAtrasadas > 0 ? { opacity: 0.85 } : {},
                                    }}
                                >
                                    <WarningAmberIcon sx={{ fontSize: 20, color: totalAtrasadas > 0 ? "#d32f2f" : "#9e9e9e" }} />
                                    <Typography fontSize={14} fontWeight={700} color={totalAtrasadas > 0 ? "#d32f2f" : "#757575"}>
                                        {totalAtrasadas}
                                    </Typography>
                                    <Typography fontSize={13} color={totalAtrasadas > 0 ? "#d32f2f" : "#757575"}>
                                        atrasada{totalAtrasadas !== 1 ? "s" : ""}
                                    </Typography>
                                </Box>
                            );
                        })()}
                    </Box>
                )}

                <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                    <Box sx={{
                        display: "flex", gap: 1, flex: 1, overflowX: "auto", overflowY: "hidden", justifyContent: "flex-start", minWidth: 0, maxWidth: "100%",
                        "&::-webkit-scrollbar": { height: 6 },
                        "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
                        "&::-webkit-scrollbar-thumb": { bgcolor: "#bdbdbd", borderRadius: 3, "&:hover": { bgcolor: "#9e9e9e" } },
                        scrollbarWidth: "thin", scrollbarColor: "#bdbdbd transparent",
                    }}>
                        {loading ? (
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                                <CircularProgress />
                            </Box>
                        ) : modulos.length === 0 ? (
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
                                <Box sx={{ textAlign: "center", maxWidth: 420 }}>
                                    <Box
                                        component="img"
                                        src="/logo192.png"
                                        alt="SysproJud"
                                        sx={{ width: 100, height: 100, mb: 3, opacity: 0.85 }}
                                    />
                                    <Typography fontSize={26} fontWeight={700} color="#091114" sx={{ mb: 1 }}>
                                        Bem-vindo ao SysproJud
                                    </Typography>
                                    <Typography fontSize={15} color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
                                        Organize seu fluxo de trabalho de forma inteligente.
                                        Gerencie tarefas, acompanhe prazos e alcance resultados com mais eficiência.
                                    </Typography>
                                    <Typography fontSize={13} color="#009BE5" fontWeight={500}>
                                        Para começar, acesse Configurações e crie seus módulos Kanban.
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            modulos.map((modulo) => {
                                const participante = isParticipante(modulo);
                                return (
                                    <Box
                                        key={modulo.id_kanban_modulo}
                                        sx={{
                                            width: 320,
                                            minWidth: 320,
                                            flexShrink: 0,
                                            height: "100%",
                                            bgcolor: modulo.cor_corpo || "#FFFFFF",
                                            borderRadius: 2,
                                            display: "flex",
                                            flexDirection: "column",
                                            overflow: "hidden",
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                bgcolor: modulo.cor_header || "#000000",
                                                color: "#fff",
                                                px: 2,
                                                py: 1,
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Box sx={{ flex: 1, textAlign: "center" }}>
                                                <Typography fontWeight={600} fontSize={15}>
                                                    {modulo.nome_modulo}
                                                </Typography>
                                                <Typography fontSize={11} sx={{ opacity: 0.8 }}>
                                                    {modulo.usuarios.length} participante{modulo.usuarios.length !== 1 ? "s" : ""}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    bgcolor: "rgba(255,255,255,0.2)",
                                                    borderRadius: "50%",
                                                    width: 28,
                                                    height: 28,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <Typography fontSize={13} fontWeight={700}>
                                                    {instancias.filter(i => i.id_kanban_modulo === modulo.id_kanban_modulo).length}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Droppable droppableId={String(modulo.id_kanban_modulo)}>
                                            {(provided, snapshot) => {
                                                let dropBg = "transparent";
                                                if (snapshot.isDraggingOver && dragOrigemIndex !== null) {
                                                    const moduloIndex = modulos.findIndex(m => m.id_kanban_modulo === modulo.id_kanban_modulo);
                                                    if (moduloIndex > dragOrigemIndex) dropBg = "#c8e6c9";
                                                    else if (moduloIndex < dragOrigemIndex) dropBg = "#ffcdd2";
                                                }
                                                return (
                                                    <Box
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                        sx={{
                                                            flex: 1,
                                                            p: 1,
                                                            overflowY: "auto",
                                                            bgcolor: dropBg,
                                                            transition: "background-color 0.2s",
                                                            minHeight: 50,
                                                            "&::-webkit-scrollbar": { width: 5 },
                                                            "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
                                                            "&::-webkit-scrollbar-thumb": { bgcolor: "#bdbdbd", borderRadius: 3, "&:hover": { bgcolor: "#9e9e9e" } },
                                                            scrollbarWidth: "thin", scrollbarColor: "#bdbdbd transparent",
                                                        }}
                                                    >
                                                        {getInstanciasDoModulo(modulo.id_kanban_modulo).map((inst, index) => (
                                                            <Draggable
                                                                key={inst.id_kanban_instancia}
                                                                draggableId={String(inst.id_kanban_instancia)}
                                                                index={index}
                                                                isDragDisabled={!participante}
                                                            >
                                                                {(provided, snapshot) => (
                                                                    <Box
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        sx={{
                                                                            mb: 1,
                                                                            border: "1px solid #e0e0e0",
                                                                            borderRadius: 1.5,
                                                                            overflow: "hidden",
                                                                            bgcolor: "#fff",
                                                                            boxShadow: snapshot.isDragging ? "0 4px 12px rgba(0,0,0,0.15)" : "none",
                                                                            cursor: participante ? "grab" : "default",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            onClick={() => toggleSection(`card-${inst.id_kanban_instancia}`)}
                                                                            sx={{ bgcolor: "#f5f5f5", px: 1.5, py: 0.8, borderBottom: "1px solid #e0e0e0", display: "flex", alignItems: "center", cursor: "pointer", "&:hover": { bgcolor: "#eeeeee" } }}
                                                                        >
                                                                            {(collapsedSections[`card-${inst.id_kanban_instancia}`] ?? true)
                                                                                ? <ExpandMoreIcon sx={{ fontSize: 18, color: "text.secondary", mr: 0.5 }} />
                                                                                : <ExpandLessIcon sx={{ fontSize: 18, color: "text.secondary", mr: 0.5 }} />
                                                                            }
                                                                            <Box sx={{ flex: 1 }}>
                                                                                <Typography fontSize={13} fontWeight={600}>
                                                                                    {inst.nome_instancia}
                                                                                </Typography>
                                                                                {inst.nome_grupo && (
                                                                                    <Typography fontSize={11} color="text.secondary">
                                                                                        {inst.nome_grupo}
                                                                                    </Typography>
                                                                                )}
                                                                                {inst.nome_responsavel && (
                                                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, mt: 0.2 }}>
                                                                                        <PersonIcon sx={{ fontSize: 12, color: "#1565c0" }} />
                                                                                        <Typography fontSize={10} color="#1565c0" fontWeight={500}>
                                                                                            {inst.nome_responsavel}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                )}
                                                                            </Box>
                                                                            <Typography fontSize={10} color="text.secondary" sx={{ mr: 0.5 }}>
                                                                                {inst.tarefas.filter(t => t.status === "finalizado").length}/{inst.tarefas.length}
                                                                            </Typography>
                                                                            {estaNoPrimeiroModulo(inst) && (
                                                                                <>
                                                                                    <Tooltip title="Editar" arrow>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            onClick={(e) => { e.stopPropagation(); handleEditarInstancia(inst); }}
                                                                                            sx={{ p: 0.3, color: "#1565c0" }}
                                                                                        >
                                                                                            <EditIcon sx={{ fontSize: 16 }} />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                    <Tooltip title="Excluir" arrow>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            onClick={(e) => { e.stopPropagation(); setExcluindoInstancia(inst); }}
                                                                                            sx={{ p: 0.3, color: "#d32f2f" }}
                                                                                        >
                                                                                            <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </>
                                                                            )}
                                                                            {podeFinalizar(inst) && (
                                                                                <Tooltip title="Finalizar" arrow>
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={(e) => { e.stopPropagation(); setFinalizarId(inst.id_kanban_instancia); }}
                                                                                        sx={{ p: 0.3, color: "#2e7d32" }}
                                                                                    >
                                                                                        <CheckCircleIcon sx={{ fontSize: 18 }} />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            )}
                                                                        </Box>
                                                                        {inst.justificativa_retorno && (
                                                                            <Box sx={{ mx: 1, mt: 0.5, p: 1, bgcolor: "#fff3e0", border: "1px solid #ffcc02", borderRadius: 1, display: "flex", alignItems: "flex-start", gap: 0.5 }}>
                                                                                <ReplyIcon sx={{ fontSize: 16, color: "#e65100", mt: 0.2 }} />
                                                                                <Box>
                                                                                    <Typography fontSize={11} fontWeight={600} color="#e65100">
                                                                                        Retornado
                                                                                    </Typography>
                                                                                    <Typography fontSize={11} color="text.secondary">
                                                                                        {inst.justificativa_retorno}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        )}
                                                                        <Collapse in={!(collapsedSections[`card-${inst.id_kanban_instancia}`] ?? true)}>
                                                                            <Box sx={{ py: 0.5 }}>
                                                                                {(() => {
                                                                                    const modulosMap: Record<string, InstanciaTarefa[]> = {};
                                                                                    inst.tarefas.forEach(t => {
                                                                                        const key = t.nome_modulo || "Geral";
                                                                                        if (!modulosMap[key]) modulosMap[key] = [];
                                                                                        modulosMap[key].push(t);
                                                                                    });
                                                                                    const grupos = Object.entries(modulosMap);
                                                                                    return grupos.map(([nomeModulo, tarefas], gi) => {
                                                                                        const sectionKey = `${inst.id_kanban_instancia}-${nomeModulo}`;
                                                                                        const isCollapsed = collapsedSections[sectionKey] ?? true;
                                                                                        return (
                                                                                            <Box key={nomeModulo}>
                                                                                                {gi > 0 && <Divider sx={{ my: 0.5 }} />}
                                                                                                <Box
                                                                                                    onClick={() => toggleSection(sectionKey)}
                                                                                                    sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 1, pt: gi > 0 ? 0.5 : 0, pb: 0.3, cursor: "pointer", "&:hover": { bgcolor: "#f0f7ff" }, borderRadius: 0.5 }}
                                                                                                >
                                                                                                    {isCollapsed
                                                                                                        ? <ExpandMoreIcon sx={{ fontSize: 16, color: "#009BE5" }} />
                                                                                                        : <ExpandLessIcon sx={{ fontSize: 16, color: "#009BE5" }} />
                                                                                                    }
                                                                                                    <ViewKanbanIcon sx={{ fontSize: 13, color: "#009BE5" }} />
                                                                                                    <Typography fontSize={11} fontWeight={600} color="#009BE5" sx={{ flex: 1 }}>
                                                                                                        {nomeModulo}
                                                                                                    </Typography>
                                                                                                    <Typography fontSize={10} color="text.secondary">
                                                                                                        {tarefas.filter(t => t.status === "finalizado").length}/{tarefas.length}
                                                                                                    </Typography>
                                                                                                </Box>
                                                                                                <Collapse in={!isCollapsed}>
                                                                                                    {tarefas.map(tarefa => {
                                                                                                        const cfg = getStatusConfig(tarefa.status);
                                                                                                        const idxModuloAtual = modulos.findIndex(m => m.id_kanban_modulo === modulo.id_kanban_modulo);
                                                                                                        const idxModuloTarefa = modulos.findIndex(m => m.id_kanban_modulo === (tarefa.id_kanban_modulo ?? 0));
                                                                                                        const bloqueadoPorResponsavel = !!(inst.id_usuario_responsavel && inst.id_usuario_responsavel !== infoLogin?.id_usuario);
                                                                                                        const podeAlterar = participante && idxModuloTarefa >= 0 && idxModuloTarefa <= idxModuloAtual && !bloqueadoPorResponsavel;
                                                                                                        return (
                                                                                                            <Box key={tarefa.id_kanban_instancia_tarefa}>
                                                                                                                <Box
                                                                                                                    sx={{
                                                                                                                        display: "flex",
                                                                                                                        alignItems: "center",
                                                                                                                        px: 0.5,
                                                                                                                        py: 0.3,
                                                                                                                        "&:hover": { bgcolor: "#fafafa" },
                                                                                                                        borderRadius: 0.5,
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <Tooltip title={podeAlterar ? cfg.label : `${cfg.label} (sem permissão)`} arrow>
                                                                                                                        <Box
                                                                                                                            component="button"
                                                                                                                            onClick={podeAlterar ? (e: React.MouseEvent<HTMLElement>) => handleOpenStatusMenu(e, tarefa) : undefined}
                                                                                                                            sx={{
                                                                                                                                display: "inline-flex",
                                                                                                                                alignItems: "center",
                                                                                                                                gap: 0.4,
                                                                                                                                border: "1px solid",
                                                                                                                                borderColor: cfg.color,
                                                                                                                                borderRadius: 1,
                                                                                                                                px: 0.8,
                                                                                                                                py: 0.2,
                                                                                                                                bgcolor: `${cfg.color}14`,
                                                                                                                                cursor: podeAlterar ? "pointer" : "default",
                                                                                                                                opacity: podeAlterar ? 1 : 0.5,
                                                                                                                                minWidth: 0,
                                                                                                                                outline: "none",
                                                                                                                                "&:hover": podeAlterar ? { bgcolor: `${cfg.color}28` } : {},
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <CircleIcon sx={{ fontSize: 8, color: cfg.color }} />
                                                                                                                            <Typography fontSize={10} fontWeight={600} color={cfg.color} noWrap>
                                                                                                                                {cfg.label}
                                                                                                                            </Typography>
                                                                                                                        </Box>
                                                                                                                    </Tooltip>
                                                                                                                    <Typography
                                                                                                                        fontSize={12}
                                                                                                                        sx={{
                                                                                                                            flex: 1,
                                                                                                                            ml: 0.8,
                                                                                                                            textDecoration: tarefa.status === "finalizado" ? "line-through" : "none",
                                                                                                                            color: tarefa.status === "finalizado" ? "text.disabled" : "text.primary",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {tarefa.nome_tarefa}
                                                                                                                    </Typography>
                                                                                                                    {(() => {
                                                                                                                        const tempoInfo = getTempoRestante(tarefa);
                                                                                                                        if (tempoInfo) {
                                                                                                                            return (
                                                                                                                                <Box sx={{
                                                                                                                                    display: "flex", alignItems: "center", gap: 0.3, ml: 1,
                                                                                                                                    bgcolor: tempoInfo.expirado ? "#ffebee" : "#e3f2fd",
                                                                                                                                    border: "1px solid",
                                                                                                                                    borderColor: tempoInfo.expirado ? "#ef5350" : "#1565c0",
                                                                                                                                    borderRadius: 1, px: 0.6, py: 0.1,
                                                                                                                                }}>
                                                                                                                                    <AccessTimeIcon sx={{ fontSize: 12, color: tempoInfo.expirado ? "#ef5350" : "#1565c0" }} />
                                                                                                                                    <Typography fontSize={10} fontWeight={700} fontFamily="monospace"
                                                                                                                                        color={tempoInfo.expirado ? "#ef5350" : "#1565c0"}>
                                                                                                                                        {tempoInfo.texto}
                                                                                                                                    </Typography>
                                                                                                                                </Box>
                                                                                                                            );
                                                                                                                        }
                                                                                                                        if (Number(tarefa.tempo_execucao_horas) > 0) {
                                                                                                                            return (
                                                                                                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, ml: 1 }}>
                                                                                                                                    <AccessTimeIcon sx={{ fontSize: 13, color: "text.secondary" }} />
                                                                                                                                    <Typography fontSize={11} color="text.secondary">
                                                                                                                                        {tarefa.tempo_execucao_horas}h
                                                                                                                                    </Typography>
                                                                                                                                </Box>
                                                                                                                            );
                                                                                                                        }
                                                                                                                        return null;
                                                                                                                    })()}
                                                                                                                </Box>
                                                                                                                {tarefa.justificativa_atraso && (
                                                                                                                    <Box sx={{ mx: 0.5, mt: 0.3, mb: 0.5, p: 0.8, bgcolor: "#ffebee", border: "1px solid #ef5350", borderRadius: 1, display: "flex", alignItems: "flex-start", gap: 0.5 }}>
                                                                                                                        <AccessTimeIcon sx={{ fontSize: 14, color: "#c62828", mt: 0.1 }} />
                                                                                                                        <Box>
                                                                                                                            <Typography fontSize={10} fontWeight={600} color="#c62828">
                                                                                                                                Atraso justificado
                                                                                                                            </Typography>
                                                                                                                            <Typography fontSize={10} color="text.secondary">
                                                                                                                                {tarefa.justificativa_atraso}
                                                                                                                            </Typography>
                                                                                                                        </Box>
                                                                                                                    </Box>
                                                                                                                )}
                                                                                                            </Box>
                                                                                                        );
                                                                                                    })}
                                                                                                </Collapse>
                                                                                            </Box>
                                                                                        );
                                                                                    });
                                                                                })()}
                                                                            </Box>
                                                                        </Collapse>
                                                                    </Box>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </Box>
                                                );
                                            }}
                                        </Droppable>
                                    </Box>
                                );
                            })
                        )}
                    </Box>
                </DragDropContext>
            </Box>

            {/* Menu de seleção de status */}
            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleCloseStatusMenu}
                slotProps={{ paper: { sx: { minWidth: 180 } } }}
            >
                {STATUS_OPTIONS.map(key => {
                    const cfg = STATUS_CONFIG[key];
                    const selected = menuTarefa?.status === key;
                    return (
                        <MenuItem
                            key={key}
                            onClick={() => handleChangeStatus(key)}
                            selected={selected}
                            dense
                        >
                            <ListItemIcon sx={{ minWidth: 28 }}>
                                <CircleIcon sx={{ fontSize: 10, color: cfg.color }} />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ fontSize: 13 }}>
                                {cfg.label}
                            </ListItemText>
                        </MenuItem>
                    );
                })}
            </Menu>

            <ModalNovaTarefaKanban
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onSaved={fetchData}
            />

            <Dialog open={finalizarId !== null} onClose={() => setFinalizarId(null)}>
                <DialogTitle>Finalizar tarefa</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Todas as tarefas foram concluídas. Deseja finalizar este card? Ele será removido do board.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setFinalizarId(null)}>Cancelar</Button>
                    <Button onClick={handleFinalizarInstancia} variant="contained" color="success">
                        Finalizar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog justificativa de retorno */}
            <Dialog open={retornoPendente !== null} onClose={() => setRetornoPendente(null)} maxWidth="sm" fullWidth>
                <DialogTitle>Justificativa de retorno</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Informe o motivo para retornar este card ao módulo anterior.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        minRows={3}
                        label="Justificativa"
                        value={justificativaRetorno}
                        onChange={e => setJustificativaRetorno(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRetornoPendente(null)}>Cancelar</Button>
                    <Button
                        onClick={handleConfirmarRetorno}
                        variant="contained"
                        color="warning"
                        disabled={!justificativaRetorno.trim()}
                    >
                        Confirmar retorno
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog editar nome do bloco */}
            <Dialog open={editandoInstancia !== null} onClose={() => setEditandoInstancia(null)} maxWidth="xs" fullWidth>
                <DialogTitle>Editar bloco</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Nome"
                        value={nomeEditInstancia}
                        onChange={e => setNomeEditInstancia(e.target.value)}
                        onKeyDown={e => { if (e.key === "Enter") handleSalvarEdicaoInstancia(); }}
                        inputProps={{ maxLength: 255 }}
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditandoInstancia(null)}>Cancelar</Button>
                    <Button onClick={handleSalvarEdicaoInstancia} variant="contained" disabled={!nomeEditInstancia.trim()}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog confirmar exclusão do bloco */}
            <Dialog open={excluindoInstancia !== null} onClose={() => setExcluindoInstancia(null)}>
                <DialogTitle>Excluir bloco</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Deseja excluir o bloco <strong>{excluindoInstancia?.nome_instancia}</strong>? Esta ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setExcluindoInstancia(null)}>Cancelar</Button>
                    <Button onClick={handleExcluirInstancia} variant="contained" color="error">
                        Excluir
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog justificativa de atraso */}
            <Dialog open={atrasoPendente !== null} onClose={() => setAtrasoPendente(null)} maxWidth="sm" fullWidth>
                <DialogTitle>Justificativa de atraso</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        O tempo de execução da tarefa <strong>{atrasoPendente?.tarefa.nome_tarefa}</strong> foi excedido. Informe o motivo do atraso.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        minRows={3}
                        label="Motivo do atraso"
                        value={justificativaAtraso}
                        onChange={e => setJustificativaAtraso(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAtrasoPendente(null)}>Cancelar</Button>
                    <Button
                        onClick={handleConfirmarAtraso}
                        variant="contained"
                        color="error"
                        disabled={!justificativaAtraso.trim()}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog tempo de execução definido pelo usuário */}
            <Dialog open={tempoPendente !== null} onClose={() => setTempoPendente(null)} maxWidth="xs" fullWidth>
                <DialogTitle>Tempo de execução</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Informe o tempo estimado de execução para a tarefa <strong>{tempoPendente?.tarefa.nome_tarefa}</strong>.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        fullWidth
                        type="number"
                        label="Horas"
                        value={tempoInput}
                        onChange={e => setTempoInput(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter') handleConfirmarTempo(); }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">h</InputAdornment>,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTempoPendente(null)}>Cancelar</Button>
                    <Button
                        onClick={handleConfirmarTempo}
                        variant="contained"
                        disabled={!tempoInput || parseFloat(tempoInput) <= 0}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal de tarefas atrasadas */}
            <Dialog open={modalAtrasadas} onClose={() => setModalAtrasadas(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <WarningAmberIcon sx={{ color: "#d32f2f" }} />
                    <Typography variant="h6" fontWeight="bold">Tarefas Atrasadas</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    {(() => {
                        const blocosAtrasados = instancias
                            .map(inst => {
                                const tarefasAtrasadas = inst.tarefas.filter(t => {
                                    const info = getTempoRestante(t);
                                    return info && info.expirado;
                                });
                                return tarefasAtrasadas.length > 0 ? { instancia: inst, tarefasAtrasadas } : null;
                            })
                            .filter(Boolean) as { instancia: KanbanInstancia; tarefasAtrasadas: InstanciaTarefa[] }[];

                        if (blocosAtrasados.length === 0) {
                            return (
                                <Typography color="text.secondary" textAlign="center" py={3}>
                                    Nenhuma tarefa atrasada no momento.
                                </Typography>
                            );
                        }

                        return blocosAtrasados.map(({ instancia, tarefasAtrasadas }, idx) => {
                            const moduloAtual = modulos.find(m => m.id_kanban_modulo === instancia.id_kanban_modulo);
                            return (
                                <Box key={instancia.id_kanban_instancia} sx={{ mb: idx < blocosAtrasados.length - 1 ? 2 : 0 }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                                        <ViewKanbanIcon sx={{ fontSize: 18, color: "#1565c0" }} />
                                        <Typography fontSize={14} fontWeight={700}>
                                            {instancia.nome_instancia}
                                        </Typography>
                                        {instancia.nome_grupo && (
                                            <Chip size="small" label={instancia.nome_grupo} variant="outlined" sx={{ fontSize: 11, height: 20 }} />
                                        )}
                                    </Box>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap", mb: 1, ml: 3.5 }}>
                                        <Typography fontSize={12} color="text.secondary">
                                            Módulo atual:
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={moduloAtual?.nome_modulo || "—"}
                                            sx={{ fontSize: 11, height: 20, bgcolor: "#e3f2fd", color: "#1565c0" }}
                                        />
                                        {instancia.nome_responsavel && (
                                            <>
                                                <Typography fontSize={12} color="text.secondary" sx={{ ml: 1 }}>
                                                    Responsável:
                                                </Typography>
                                                <Chip
                                                    size="small"
                                                    icon={<PersonIcon sx={{ fontSize: 13 }} />}
                                                    label={instancia.nome_responsavel}
                                                    sx={{ fontSize: 11, height: 20, bgcolor: "#e8eaf6", color: "#283593" }}
                                                />
                                            </>
                                        )}
                                    </Box>
                                    {tarefasAtrasadas.map(tarefa => {
                                        const tempoInfo = getTempoRestante(tarefa);
                                        return (
                                            <Box
                                                key={tarefa.id_kanban_instancia_tarefa}
                                                sx={{
                                                    display: "flex", alignItems: "center", gap: 1,
                                                    ml: 3.5, mb: 0.5, py: 0.6, px: 1.2,
                                                    bgcolor: "#fff5f5", borderRadius: 1,
                                                    border: "1px solid #ffcdd2",
                                                }}
                                            >
                                                <AccessTimeIcon sx={{ fontSize: 15, color: "#d32f2f" }} />
                                                <Typography fontSize={13} sx={{ flex: 1 }}>
                                                    {tarefa.nome_tarefa}
                                                </Typography>
                                                {tarefa.nome_modulo && (
                                                    <Chip
                                                        size="small"
                                                        label={tarefa.nome_modulo}
                                                        sx={{ fontSize: 10, height: 18, bgcolor: "#fce4ec", color: "#c62828" }}
                                                    />
                                                )}
                                                {tempoInfo && (
                                                    <Typography fontSize={12} fontWeight={700} color="#d32f2f">
                                                        {tempoInfo.texto}
                                                    </Typography>
                                                )}
                                            </Box>
                                        );
                                    })}
                                    {idx < blocosAtrasados.length - 1 && <Divider sx={{ mt: 2 }} />}
                                </Box>
                            );
                        });
                    })()}
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 1.5 }}>
                    <Button onClick={() => setModalAtrasadas(false)} variant="outlined" color="inherit">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={!!snackMsg}
                autoHideDuration={4000}
                onClose={() => setSnackMsg("")}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={() => setSnackMsg("")} severity="warning" variant="filled" sx={{ width: "100%" }}>
                    {snackMsg}
                </Alert>
            </Snackbar>
        </Templete>
    );
}
